import { combineReducers } from 'redux'
import { configureStore } from '@reduxjs/toolkit'

import {
  persistStore,
  persistReducer,
  createMigrate,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import migrations from './Migrations'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import storage from 'redux-persist/lib/storage'
import { thunk } from 'redux-thunk'

import Reactotron from 'reactotron-react-js'
import { reactotronRedux } from 'reactotron-redux'

import authentication from './Reducers/Authentication'
import company from './Reducers/Company'
import category from './Reducers/Category'
import conversations from './Reducers/Conversations'
import utility from './Reducers/Utility'

import config from '../config/env'

const persistConfig = {
  key: 'root',
  storage,
  version: 0,
  stateReconciler: autoMergeLevel2,
  migrate: createMigrate(migrations, { debug: false }),
}

const reducers = persistReducer(
  persistConfig,
  combineReducers({
    authentication,
    company,
    category,
    conversations,
    utility,
  }),
)

let store

if (config.ENV === 'local') {
  const reactotron = Reactotron.configure({ host: '192.168.0.37' })
    .use(reactotronRedux())
    .connect()

  store = configureStore({
    reducer: reducers,
    enhancers: getDefaultEnhancers =>
      getDefaultEnhancers().concat(reactotron.createEnhancer()),
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }).concat(thunk),
  })

  //   store = configureStore(
  //     { reducer: reducers },
  //     undefined,
  //     compose(applyMiddleware(...middlewares), reactotron.createEnhancer()),
  //   )
} else {
  store = configureStore({
    reducer: reducers,
    enhancers: getDefaultEnhancers => getDefaultEnhancers(),
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }).concat(thunk),
  })
}

let persistor = persistStore(store)

export { store, persistor }
